import gsap from 'gsap'
import { forEach } from 'lodash'

import {
  batchRevealAnimation,
  fadeRevealAnimation,
  getScrollTriggerOptions
} from '@/components/sections/animations/shared'

import { Animation } from '@/types'

export const gridPostTypesRevealAnimation = ({
  node,
  context,
  reverse,
  delay = 0
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const cards = selector('[data-motion-card]')

  let cardsBatchAnimation: ScrollTrigger[]
  if (cards.length > 0) {
    cardsBatchAnimation = batchRevealAnimation({
      targets: cards,
      reverse,
      delay,
      stagger: {
        amount: 0.24
      }
    })
  }

  return () => {
    forEach(cardsBatchAnimation || [], (animation) => animation.kill())
  }
}

export const gridPostTypesFiltersRevealAnimation = ({
  node,
  reverse,
  delay = 0
}: Animation) => {
  const timeline = gsap
    .timeline({
      ...getScrollTriggerOptions(node, reverse),
      delay
    })
    .add(fadeRevealAnimation(node).timeline)

  return () => {
    timeline.kill()
  }
}
